import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    toggle() {
        document.body.classList.toggle('show-luxury-menu');

        if (document.body.classList.contains('show-luxury-menu')) {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    }

    close() {
        document.body.classList.remove('show-luxury-menu');
    }
}
